import { useCallback } from "react";

import { losPipelineApi } from "../../api/losPipelineApi";
import { dealsForTab } from "../../constants/pipelineTabs";
import { BOARD_LAYOUT_SCOPE } from "../../hooks/utils/useUserPreferences";
import PipelineTableScreen from "./PipelineTableScreen";

// Post Close tab. Per loan_and_auth_endpoints.md §3–§4 there is NO per-stage
// endpoint — this is a client-side slice of the shared
// /underwriting/underwriting_pipeline payload, filtered to the "Post Close"
// bucket (pipeline "Closed" / loanStatus "Closed"; incl. post-close conditions).
const PostClosePipelineScreen = () => {
  const fetchData = useCallback(({ onSuccessFn, onFailFn, onErrorFn }) => {
    const onError = onFailFn || onErrorFn || (() => {});
    losPipelineApi
      .getUnderwritingPipeline()
      .then((deals) => onSuccessFn?.(dealsForTab(deals, "POST_CLOSE")))
      .catch(onError);
  }, []);

  return (
    <PipelineTableScreen
      title="Post Close"
      storageKeyPrefix="post-close-pipeline"
      // Shares the saved-view list with Pre-Close (same column set) and syncs to
      // the user profile; the default-layout pointer stays per board.
      layoutScope={BOARD_LAYOUT_SCOPE}
      syncLayoutsToProfile
      fetchData={fetchData}
    />
  );
};

export default PostClosePipelineScreen;
